/* eslint-disable camelcase */

import { Row, intlShape, withIntl } from "lcm-iot-commons";

type Props = {
  itemHeader: string;
  itemVariable: string;
  itemChannel: string;
  intl: intlShape;
};

export function FieldGatewayModbusConfigItem({
  itemHeader,
  itemVariable,
  itemChannel,
  intl,
}: Props) {
  const { t } = intl;
  return (
    <>
      <Row>
        <div className="col-lg-3">
          {/* @ts-expect-error TS(2349) FIXME: This expression is not callable. */}
          <b>{t`field_gateway.modbus.config.item.valuename`}</b>
        </div>
        <div className="col-lg-2">{itemHeader}</div>
      </Row>
      <Row>
        <div className="col-lg-3">
          {/* @ts-expect-error TS(2349) FIXME: This expression is not callable. */}
          <b>{t`field_gateway.modbus.config.item.channel`}</b>
        </div>
        <div className="col-lg-2">{itemChannel}</div>
      </Row>
      <Row>
        <div className="col-lg-3">
          {/* @ts-expect-error TS(2349) FIXME: This expression is not callable. */}
          <b>{t`field_gateway.modbus.config.item.variable`}</b>
        </div>
        <div className="col-lg-2">{itemVariable}</div>
      </Row>
    </>
  );
}

export default withIntl(FieldGatewayModbusConfigItem);
